export const API_ENDPOINTS = {
  DASHBOARD: {
        GET_SYSTEM_COUNTS: "Dashboard/SystemCounts",
        GET_RECENT_CLAIMS: "Dashboard/RecentClaims",
        GET_CLAIM_BY_STATUS: "Dashboard/ClaimByStatus",
        GET_RECENT_ACTIVITIES: "Dashboard/RecentActivity",
        GET_TOP_COMPANIES_BY_CLAIMS: "Dashboard/TopCompanies",
        GET_TOP_PROVIDERS_BY_CLAIMS: "Dashboard/TopProviders",
  },
 
  // Add other modules like EMPLOYEE, DEPARTMENT etc.
};

export const QUERY_KEYS = {
 DASHBOARD: {
    USERS: ["GetUsers"],
  },
  
};